import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IScorecardPreview } from '../../shared/models/scorecard-preview.model';
import { ScorecardModel, IScorecard } from '../../shared/models/scorecard.model';
import {
  IScorecardChallengeRequest,
  IStatementChallengeCreateRequest,
  TChallengeUpdateOperation,
} from '../../shared/interfaces/challenge.interface';
import { IStatement } from '../../shared/models/scorecard-section.model';

export const SCORECARD_PREVIEW_API_ACTIONS = createActionGroup({
  source: 'Scorecard Preview API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: IScorecardPreview[] }>(),
  },
});

export const STATEMENT_CREATE_CHALLENGE_API_ACTIONS = createActionGroup({
  source: 'Statement Create Challenge API',
  events: {
    create: props<{ data: IStatementChallengeCreateRequest }>(),
    error: props<{ statementId: number }>(),
    success: props<{ data: IStatement }>(),
  },
});

export const SCORECARD_DETAILS_API_ACTIONS = createActionGroup({
  source: 'Scorecard API',
  events: {
    get: props<{ scorecardId: string }>(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ScorecardModel }>(),
  },
});

export const STATEMENT_CHALLENGE_UPDATE_API_ACTIONS = createActionGroup({
  source: 'Statement Update Challenge API',
  events: {
    update: props<{
      challengeId: number;
      statementId: number;
      operation: TChallengeUpdateOperation;
      comment?: string;
    }>(),
    error: props<{ challengeId: number }>(),
    success: props<{ data: IStatement; challengeId: number }>(),
  },
});

export const SCORECARD_CHALLENGE_API_ACTIONS = createActionGroup({
  source: 'Scorecard Challenge API',
  events: {
    execute: props<IScorecardChallengeRequest>(),
    error: emptyProps(),
    success: props<{ data: IScorecard }>(),
  },
});
